export function getLayersDef() {
	return {
		DEF_BASE: 1,
		DEF_TURIST: 2,
		DEF_OPHOTO: 3,
		DEF_GEOGRAPHY: 23,
		DEF_TURIST_WINTER: 19,
		DEF_TURIST_NEW: 28,
		DEF_HISTORIC: 5,
		DEF_HYBRID: 4,
		DEF_HYBRID_SPARSE: 25,
		DEF_OPHOTO0203: 8,
		DEF_OPHOTO0406: 9,
		DEF_OPHOTO1415: 26,
		DEF_OPHOTO1618: 29,
		DEF_OPHOTO1012: 24,
		DEF_SUMMER: 21,
		DEF_TRAIL: 7,
		DEF_BIKE: 6,
		DEF_RELIEF: 17,
		DEF_OBLIQUE: 12,
		DEF_BASE_NEW: 27,
		DEF_SMART_BASE: 14,
		DEF_SMART_TURIST: 16,
		DEF_SMART_OPHOTO: 15,
		DEF_SMART_WINTER: 20,
		DEF_SMART_SUMMER: 22,
		DEF_PANO: 18,
		// neexistuje v api, ale pouziva se
		DEF_OBLIQUE_HYBRID: 100,
	};
}

interface ILayersConfig {
	mapServer: string;
}

export function getLayersConfig({
	mapServer,
}: ILayersConfig) {
	const CONFIG = {};
	const layersDef = getLayersDef();
	const year = new Date().getFullYear();

	CONFIG[layersDef.DEF_BASE] = {
		zoom: [2, 19],
		label: "Obecná",
		labelLocaleKey: "base",
		preview: "preview-zakladni.png",
		url: `${mapServer}/base-m/`,
		retinaUrl: `${mapServer}/base-m/retina/`,
		langs: {
			en: {
				url: `${mapServer}/base-en/`,
				retinaUrl: `${mapServer}/base-en/retina/`,
			},
		},
		copyright: {
			"-": [
				`<a href='https://o.seznam.cz' target='_blank' rel='noopener'>Seznam.cz, a.s.</a>, ${year}`,
				`<a href='https://www.openstreetmap.org/copyright' target='_blank' rel='noopener'>OpenStreetMap contributors</a>`,
			],
			"-7": "NASA",
		},
	};

	CONFIG[layersDef.DEF_OPHOTO] = {
		zoom: [2, 19],
		label: "Letecká",
		labelLocaleKey: "ophoto",
		preview: "preview-letecka.png",
		// !!! override - prevzaty z mapy.ts
		url: `${mapServer}/bing/`,
		//url: `${mapServer}/ophoto-m/`,
		copyright: {
			"7-": `<a href='https://o.seznam.cz' target='_blank' rel='noopener'>Seznam.cz, a.s.</a>, ${year}`,
			"0-7": "NASA Earth Observatory",
			"8-13": "<a href='https://eox.at/' target='_blank' rel='noopener'>EOX IT Services GmbH</a>",
			"9-20": "TopGis, s.r.o.",
			"9-19": "GKÚ Bratislava, NLC",
			"12-18": "GURS",
			"12-19": ["Geoland.at", "swisstopo", "GUGiK"],
			"0-19": "<a href='https://www.openstreetmap.org/copyright' target='_blank' rel='noopener'>OpenStreetMap contributors</a>",
		},
	};

	CONFIG[layersDef.DEF_TURIST] = {
		zoom: [2, 19],
		label: "Turistická",
		labelLocaleKey: "turist",
		preview: "preview-turisticka.png",
		url: `${mapServer}/turist-m/`,
		retinaUrl: `${mapServer}/turist-m/retina/`,
		langs: {
			en: {
				url: `${mapServer}/turist-en/`,
				retinaUrl: `${mapServer}/turist-en/retina/`,
			},
		},
		copyright: {
			"-": [
				`<a href='https://o.seznam.cz' target='_blank' rel='noopener'>Seznam.cz, a.s.</a>, ${year}`,
				`<a href='https://www.openstreetmap.org/copyright' target='_blank' rel='noopener'>OpenStreetMap contributors</a>`,
			],
			"-15": "NASA",
		},
	};

	CONFIG[layersDef.DEF_GEOGRAPHY] = {
		zoom: [2, 18],
		label: "Zeměpisná",
		labelLocaleKey: "geography",
		preview: "preview-zemepisna.png",
		url: `${mapServer}/zemepis-m/`,
		copyright: CONFIG[layersDef.DEF_TURIST].copyright,
	};


	CONFIG[layersDef.DEF_TURIST_WINTER] = {
		zoom: [2, 19],
		label: "Zimní",
		labelLocaleKey: "winter",
		preview: "preview-zimni.png",
		url: `${mapServer}/winter-m/`,
		retinaUrl: `${mapServer}/winter-m/retina/`,
		downUrl: `${mapServer}/winter-m-down/`,
		upUrl: `${mapServer}/winter-m-up/`,
		langs: {
			en: {
				url: `${mapServer}/winter-en/`,
				retinaUrl: `${mapServer}/winter-en/retina/`,
				downUrl: `${mapServer}/winter-en-down/`,
				upUrl: `${mapServer}/winter-en-up/`,
			},
		},
		copyright: CONFIG[layersDef.DEF_TURIST].copyright,
	};

	CONFIG[layersDef.DEF_HISTORIC] = {
		zoom: [5, 15],
		label: "Historická",
		labelLocaleKey: "historic",
		title: "Historická 1836–1852",
		titleLocaleKey: "historic",
		preview: "preview-historicka.png",
		url: `${mapServer}/army2-m/`,
		copyright: {
			"-": ["2nd Military Survey, Austrian State Archive", "MŽP ČR", "UJEP"],
		},
	};

	CONFIG[layersDef.DEF_HYBRID] = {
		options: {
			animTime: 0,
			fadeTime: 0,
			prefetch: 0,
			alpha: true,
		},
		url: `${mapServer}/hybrid-base-m/`,
		langs: {
			en: {
				url: `${mapServer}/hybrid-base-en/`,
			},
		},
		copyright: {
			"-": [
				`<a href='https://o.seznam.cz' target='_blank' rel='noopener'>Seznam.cz, a.s.</a>, ${year}`,
			],
		},
	};

	CONFIG[layersDef.DEF_HYBRID_SPARSE] = {
		options: {
			animTime: 0,
			fadeTime: 0,
			prefetch: 0,
			alpha: true,
		},
		url: `${mapServer}/hybrid-sparse-m/`,
		langs: {
			en: {
				url: `${mapServer}/hybrid-sparse-en/`,
			},
		},
		copyright: {
			"-": [
				`<a href='https://o.seznam.cz' target='_blank' rel='noopener'>Seznam.cz, a.s.</a>, ${year}`,
			],
		},
	};

	CONFIG[layersDef.DEF_OPHOTO0203] = {
		zoom: [2, 20],
		url: `${mapServer}/ophoto0203-m/`,
		label: "Letecká 03",
		labelLocaleKey: "ophoto0203",
		title: "Letecká 2002–2003",
		titleLocaleKey: "ophoto0203",
		preview: "preview-letecka0203.png",
		copyright: CONFIG[layersDef.DEF_OPHOTO].copyright,
	};

	CONFIG[layersDef.DEF_OPHOTO0406] = {
		zoom: [2, 20],
		url: `${mapServer}/ophoto0406-m/`,
		label: "Letecká 06",
		labelLocaleKey: "ophoto0406",
		title: "Letecká 2004–2006",
		titleLocaleKey: "ophoto0406",
		preview: "preview-letecka0406.png",
		copyright: CONFIG[layersDef.DEF_OPHOTO].copyright,
	};

	CONFIG[layersDef.DEF_OPHOTO1415] = {
		zoom: [2, 20],
		url: `${mapServer}/ophoto1415-m/`,
		label: "Letecká 15",
		labelLocaleKey: "ophoto1415",
		title: "Letecká 2014–2015",
		titleLocaleKey: "ophoto1415",
		preview: "preview-letecka0406.png",
		copyright: CONFIG[layersDef.DEF_OPHOTO].copyright,
	};

	CONFIG[layersDef.DEF_OPHOTO1618] = {
		zoom: [2, 20],
		url: `${mapServer}/ophoto1618-m/`,
		label: "Letecká 18",
		labelLocaleKey: "ophoto1618",
		title: "Letecká 2016–2018",
		titleLocaleKey: "ophoto1618",
		preview: "preview-letecka0406.png",
		copyright: CONFIG[layersDef.DEF_OPHOTO].copyright,
	};

	CONFIG[layersDef.DEF_SUMMER] = {
		zoom: [2, 18],
		url: `${mapServer}/turist_aquatic-m/`,
		label: "Letní",
		labelLocaleKey: "summer",
		title: "Letní",
		titleLocaleKey: "summer",
		preview: "preview-letni.png",
		copyright: CONFIG[layersDef.DEF_TURIST].copyright,
	};

	CONFIG[layersDef.DEF_TRAIL] = {
		options: {
			animTime: 0,
			fadeTime: 0,
			prefetch: 0,
			alpha: true,
		},
		url: `${mapServer}/hybrid-turist-m/`,
		langs: {
			en: {
				url: `${mapServer}/hybrid-turist-en/`,
			},
		},
		copyright: {
			"-": `<a href='https://o.seznam.cz' target='_blank' rel='noopener'>Seznam.cz, a.s.</a>, ${year}`,
		},
	};

	CONFIG[layersDef.DEF_BIKE] = {
		options: {
			animTime: 0,
			fadeTime: 0,
			prefetch: 0,
			alpha: true,
		},
		url: `${mapServer}/hybrid-turist-m/`,
		langs: {
			en: {
				url: `${mapServer}/hybrid-turist-en/`,
			},
		},
		copyright: {
			"-": `<a href='https://o.seznam.cz' target='_blank' rel='noopener'>Seznam.cz, a.s.</a>, ${year}`,
		},
	};

	CONFIG[layersDef.DEF_RELIEF] = {
		zoom: [3, 15],
		options: {
			animTime: 0,
			fadeTime: 0,
			prefetch: 0,
			alpha: true,
		},
		url: `${mapServer}/relief-m/`,
		copyright: {
			"-": `<a href='https://o.seznam.cz' target='_blank' rel='noopener'>Seznam.cz, a.s.</a>, ${year}`,
		},
	};

	CONFIG[layersDef.DEF_OBLIQUE] = {
		url: `${mapServer}/oblique/`,
		copyright: {
			geodis: [
				`<a href='https://o.seznam.cz' target='_blank' rel='noopener'>Seznam.cz, a.s.</a>, ${year}`,
				`GEODIS BRNO, s.r.o.`,
			],
			topgis: [
				`<a href='https://o.seznam.cz' target='_blank' rel='noopener'>Seznam.cz, a.s.</a>, ${year}`,
				"TopGis, s.r.o.",
			],
		},
	};

	CONFIG[layersDef.DEF_BASE_NEW] = CONFIG[layersDef.DEF_BASE];

	CONFIG[layersDef.DEF_TURIST_NEW] = CONFIG[layersDef.DEF_TURIST];

	CONFIG[layersDef.DEF_SMART_BASE] = {
		label: "Obecná",
		labelLocaleKey: "base",
		preview: "preview-zakladni.png",
	};

	CONFIG[layersDef.DEF_SMART_TURIST] = {
		label: "Turistická",
		labelLocaleKey: "turist",
		preview: "preview-turisticka.png",
		url: `${mapServer}/turist-m/`,
	};

	CONFIG[layersDef.DEF_SMART_OPHOTO] = {
		label: "Letecká",
		labelLocaleKey: "ophoto",
		preview: "preview-letecka.png",
	};

	CONFIG[layersDef.DEF_SMART_WINTER] = {
		label: "Zimní",
		labelLocaleKey: "winter",
		preview: "preview-zimni.png",
	};

	CONFIG[layersDef.DEF_SMART_SUMMER] = {
		label: "Letní",
		labelLocaleKey: "summer",
		preview: "preview-letni.png",
	};

	CONFIG[layersDef.DEF_PANO] = {
		zoom: [2, 20],
		options: {
			availUrl: `${mapServer}/getMultiple?path=/panorama_mask-m/&tiles`,
		},
		url: `${mapServer}/panorama_hybrid-m/`,
	};

	CONFIG[layersDef.DEF_OPHOTO1012] = {
		zoom: [2, 19],
		label: "Letecká 2012",
		labelLocaleKey: "ophoto1012",
		preview: "preview-letecka.png",
		url: `${mapServer}/ophoto1012-m/`,
		copyright: {
			"7-": `<a href='https://o.seznam.cz' target='_blank' rel='noopener'>Seznam.cz, a.s.</a>, ${year}`,
			"0-8": "NASA Earth Observatory",
			"9-": "GEODIS BRNO, s.r.o.",
			"9-12": "USGS &amp; NASA",
			"7-12": "<a href='https://www.openstreetmap.org/copyright' target='_blank' rel='noopener'>OpenStreetMap contributors</a>",
		},
	};

	return CONFIG;
}
